module.exports = __webpack_public_path__ + "img/linkedin.bc872a2a.svg";